<template>
  <div id="scroll-focusGroups">
    <dv-scroll-board :config="config"/>
  </div>
</template>

<script>
export default {
  name: 'FocusGroups',
  data () {
    return {
      config: {
        header: ['时间', '描述', '迁入/迁出'],
        data: [
          ['2023-12-29 18:30:10', '重点人群A类 杨*婷 迁入 丽水雅苑 九栋 五单元 908', '迁入'],
          ['2023-12-30 09:15:45', '重点人群D类 李*明 迁入 华景小区 三栋 二单元 302', '迁入'],
          ['2023-12-19 08:45:12', '重点人群C类 刘*杰  迁出 幸福家园 四栋 三单元 502', '迁出'],
          ['2023-12-16 10:15:50', '重点人群B类 张*伟 迁入 金地豪庭 四栋 三单元 1106', '迁入'],
          ['2023-12-16 10:15:50', '普通人群D类 赵* 迁出 华景小区 一栋 五单元 1803', '迁出'],
          ['2023-11-23 10:15:50', '重点人群B类 孙*风 迁入 未来城 五栋 十一单元 1203', '迁入'],
          ['2023-11-22 12:34:50', '重点人群B类 赵*宇 迁入 未来城 一栋 五单元 1203', '迁入'],
          ['2023-11-21 11:56:50', '重点人群B类 赵* 迁入 未来城 三栋 二单元 808', '迁入']
        ],
        index: true,
        columnWidth: [50, 150, 360, 100],
        align: ['center'],
        rowNum: 7,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  }
}
</script>

<style lang="less">
#scroll-focusGroups {
  width: 100%;
  height: 400px;
}
</style>
